module.exports = __webpack_public_path__ + "img/server-3.863a3f40.jpg";